import { RequestViewMode } from '@/modules/support/types/RequestViewMode.ts'
import { RequestType } from '@/modules/support/types/RequestType.ts'
import { appConfig } from '@/config/app.ts'

export interface RequestState {
  isLoading: boolean
  requestType: RequestType
  viewMode: RequestViewMode
  filters: string
}

export const initialState: RequestState = {
  isLoading: false,
  requestType: 'WARRANTY_RELEASE',
  viewMode: 'board',
  filters: `?limit=${appConfig.pagination.defaultValue}`
}
